import type { Segno, SourceType } from '../types'

export type AuthoringSourceMode = SourceType | 'SEGNO_FILE'

export type AuthoringSnapshotInput = {
  sourceType: SourceType
  sourceMode: AuthoringSourceMode
  title: string
  mediaFileId: string | null
  youtubeUrl: string
  segnos: Segno[]
}

export function authoringSnapshot(input: AuthoringSnapshotInput): string {
  return JSON.stringify({
    sourceType: input.sourceType,
    sourceMode: input.sourceMode,
    title: input.title,
    mediaFileId: input.mediaFileId,
    youtubeUrl: input.youtubeUrl.trim(),
    segnos: input.segnos.map((segno) => ({
      order: segno.order,
      title: segno.title,
      startTime: segno.startTime,
      endTime: segno.endTime,
      lyrics: segno.lyrics ?? '',
    })),
  })
}
